<template>
  <div class="course-step">
    <weui-group :notitle="true" tips="绑定教练即可随时同步教练的课程安排，并且可以发起课程申请、查看过往锻炼记录。">
      <weui-button-cell :to="{ name: ROUTE_SHARE_BINDING, params: { hash: this.hash } }" replace>立刻绑定您的私人教练</weui-button-cell>
    </weui-group>
    <course-view :course="course" />
  </div>
</template>

<script>
import { createNamespacedHelpers } from 'vuex';

import { WeuiGroup, WeuiCell, WeuiButtonCell } from '@/components/weui';
import CourseView from '@/components/course/View';

import { ROUTE_SHARE_BINDING } from '@/router/names';
import { FETCH_COURSE } from '@/store/share/types';


const { mapActions, mapState } = createNamespacedHelpers('share');

export default {
    props: {
        hash: {
            type: String,
            required: true,
        },
    },
    data() {
        return {
            ROUTE_SHARE_BINDING,
        };
    },
    computed: {
        ...mapState({
            course: state => (state.course || {}),
        }),
    },
    created() {
        this.fetchCourse({
            hash: this.hash,
        });
    },
    mounted() {
        document.title = '新的课程安排';
    },
    methods: {
        ...mapActions({
            fetchCourse: FETCH_COURSE,
        }),
    },
    components: {
        WeuiGroup,
        WeuiCell,
        WeuiButtonCell,
        CourseView,
    },
};
</script>



// WEBPACK FOOTER //
// src/components/share/Course.vue